module.exports = __webpack_public_path__ + "static/media/p6.12b7f9f7.png";